import { loadEnrollmentDocument } from "./enrollmentStorage";

const joinGuardianDetails = (name, dni) =>
  [name, dni ? `DNI ${dni}` : ""].filter(Boolean).join(" · ");

export const anexoGuardianFieldIds = new Set([
  "guardian_clarification",
  "guardian_2_clarification",
  "guardian_relationship",
  "guardian_2_relationship",
]);

export function mapSolicitudToAnexoValues(solicitud, dni = "") {
  if (!solicitud || !Object.keys(solicitud).length) return {};

  const firstGuardian = {
    name: solicitud.guardian_1_name,
    dni: solicitud.guardian_1_dni,
    relationship: solicitud.guardian_1_relationship,
  };
  const secondGuardian = {
    name: solicitud.guardian_2_name,
    dni: solicitud.guardian_2_dni,
    relationship: solicitud.guardian_2_relationship,
  };
  const hasGuardian = ({ name, dni, relationship }) => name || dni || relationship;

  if (!hasGuardian(firstGuardian) && !hasGuardian(secondGuardian) &&
      (solicitud.contract_clarification || solicitud.contract_dni || solicitud.contract_relationship)) {
    firstGuardian.name = solicitud.contract_clarification;
    firstGuardian.dni = solicitud.contract_dni;
    firstGuardian.relationship = solicitud.contract_relationship;
  }

  return {
    student_dni: solicitud.student_dni || dni,
    student_name_first_line: solicitud.student_name || "",
    guardian_clarification: joinGuardianDetails(firstGuardian.name, firstGuardian.dni),
    guardian_2_clarification: joinGuardianDetails(secondGuardian.name, secondGuardian.dni),
    guardian_relationship: firstGuardian.relationship || "",
    guardian_2_relationship: secondGuardian.relationship || "",
  };
}

export async function getAnexoPrefillValues(dni) {
  return mapSolicitudToAnexoValues(await loadEnrollmentDocument(dni, "solicitud"), dni);
}
